export default __webpack_public_path__ + "static/EmilyJamison-bc5898a4f6e3af3e25ee2649a5a6a22d.png";